import "./wayfinder_hotspot_variant.js";
//#region src/wayfinder_hotspot_variant_helper.ts
let WayfinderHotspotVariantHelper;
(function(_WayfinderHotspotVariantHelper) {
	function name(variant) {
		switch (variant) {
			case "other": return "Other";
			case "kiosk": return "Kiosk";
		}
	}
	_WayfinderHotspotVariantHelper.name = name;
})(WayfinderHotspotVariantHelper || (WayfinderHotspotVariantHelper = {}));
//#endregion
export { WayfinderHotspotVariantHelper };

//# sourceMappingURL=wayfinder_hotspot_variant_helper.js.map